import React from 'react';

import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Button from '../../elements/Button';
import TextArea from '../../fields/TextArea';
import styles from './styles.scoped.css';

export default function Component({
  // dataModal = {},
  // item = {},
  labelBtn = '',
  labelTextInput = '',
  onCloseModal = () => { },
  placeholder = '',
  handleSubmit = () => { }
}) {
  const reason = {
    label: labelTextInput,
    placeholder: placeholder,
  };

  return (
    <form onSubmit={handleSubmit}>
      <Field
        className={styles.textArea}
        component={TextArea}
        inputProps={reason}
        name="reason"
      />
      <div className={styles.containerButton}>
        <Button className={styles.btnOutline} onClick={onCloseModal}>
          Batal
        </Button>
        <Button
          className={styles.btnPrimary}
          onClick={() => { }}
          type={'submit'}
        >
          {labelBtn}
        </Button>
      </div>
    </form>
  );
}

Component.propTypes = {
  change: PropTypes.func.isRequired,
  dataModal: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  item: PropTypes.object,
  labelBtn: PropTypes.string,
  labelTextInput: PropTypes.string,
  onCloseModal: PropTypes.func,
  placeholder: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
};
